const Q = require('q');
const __request = require(`./__request/__request_contentType_form`);

const web_credit_creditFlow = function (pParameter) {
    if (!pParameter) pParameter = {};
    // 授信流水分页查询 ：http://219.128.52.2:18001/doc.html#/credit/credit-account-controller/creditFlowUsingPOST

    return Q.when().then(function () {
        return __request({
            method: 'POST',
            urlSuffix: '/web/credit/creditFlow',
            data: pParameter,
        });
    }).catch(function (ex) {
        console.error(ex);
        if (ex) {
            if (ex.stack) {
                console.error(ex.stack);
            }
        }
        return Q.reject(ex);
    });
};

module.exports = web_credit_creditFlow;